<!--
    @file:主页面,所有的路由主页面
-->
<template>
    <div id="home">
        <v-header :ismenu="ismenu"></v-header>
        <div v-bind:class="{ container: ismenu }">
            <v-breadcrumb v-if="ismenu" ></v-breadcrumb>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import header from './plugins/header';
import breadcrumb from './plugins/breadcrumb';
export default {
    name: 'home',
    created () {
    },
    data () {
        return {
            crumb: 'test'
        };
    },
    components: {
        'v-header': header,
        'v-breadcrumb': breadcrumb
    },
    computed: {
        ismenu: function () {
            // main模块顶部不显示menu
            return !(this.$route.name === 'main');
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
    padding: 0 60px;
}
@media screen and (max-width:1367px){
    .container{
        padding: 0 10px;
    }
}

</style>
<style>
.el-button--primary{
    width: 100%;
    background-color: #5182e4;
    border-color: #5182e4;
    color:#fff;
    padding: 7px 15px;
    border-radius: 0;
}
.el-button--primary:focus,.el-button--primary:hover{
    background-color: #0066ff;
}
.el-input__inner::-webkit-input-placeholder { /* WebKit browsers */
    color:#e0e3e7;
    font-size: 12px;
}
.setting-title{
    position: relative;
    text-align: left;
    padding-left: 22px;
    background-image: url(../assets/img/time.png);
    background-repeat: no-repeat;
    background-position: left center;
}
.car{
    background-image: url(../assets/img/car.png);
}
.speed{
    background-image: url(../assets/img/speedometer.png);
}
.progress{
    background-image: url(../assets/img/process.png);
}
.car-table{
    border:1px solid #ddd;
    border-right: none;
    border-bottom: none;
    margin-bottom: 10px;
}
.car-table td{
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    padding: 4px 10px;
    text-align: center;
    min-width: 120px;
}

</style>



// WEBPACK FOOTER //
// home.vue?cb0fccec